import React, { useEffect, useState } from 'react';
import api from '@utils/api';
import classNames from 'classnames';
const LoginContentAssetInfoMessage = (props) => {
    const [contentAssetMessage, setContentAssetMessage] = useState(null);
    useEffect(() => {
        api.getContentAsset(props.contentAssetID).then((data) => {
            if (!data.error) {
                setContentAssetMessage(data === null || data === void 0 ? void 0 : data.body);
                console.log('data.body', data.body);
            }
        });
    }, []);
    if (!contentAssetMessage)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: classNames(['content-asset-message', 'alert-on-link', ...(props.customClasses || [])]) },
        React.createElement("p", { dangerouslySetInnerHTML: { __html: contentAssetMessage } })));
};
export default LoginContentAssetInfoMessage;
